import React from 'react';
import Button from './ui/Button';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiPhone } from 'react-icons/fi';

export default function Navbar() {
  return (
    <header className="fixed top-0 left-0 w-full z-[100]">
      {/* Contact Top Bar */}
      <div className="bg-charcoal text-white/90 py-2 px-6 md:px-12 text-[11px] tracking-[0.15em] uppercase flex justify-center md:justify-end items-center gap-2 font-medium">
        <SafeIcon icon={FiPhone} className="w-3 h-3 text-blush" />
        <a href="tel:602-805-5051" className="hover:text-blush transition-colors">602-805-5051</a>
      </div>
      
      {/* Main Nav */}
      <nav className="bg-warmWhite/90 backdrop-blur-md border-b border-gray-100 py-4 px-6 md:px-12 flex justify-between items-center transition-all duration-300">
        <Link to="/" className="inline-block hover:opacity-80 transition-opacity">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/2ba49265b1864ee4c7db35ffc36715be.png" 
            alt="SmileVase Logo" 
            className="h-8 md:h-10 w-auto object-contain"
          />
        </Link>
        
        <div className="flex items-center">
          <Button 
            href="https://florist.smilevase.com" 
            className="!py-2.5 !px-6 !text-[11px] !tracking-widest"
          >
            Order Portal
          </Button>
        </div>
      </nav>
    </header>
  );
}